import { browser } from '$app/environment';
import { page } from '$app/state';
import { getLanguageCode } from '$lib/i18n/language';
import { addScriptTag } from '$lib/services/advertising/script';
import { handleVendorConsent } from '$lib/services/tracking/didomi/consent';
import { SCRIPT_ID, SCRIPT_SRC, TEADS_BUYER_PIXEL_ID, TEADS_PIXEL_VENDOR_ID } from '$lib/services/tracking/teadsPixel/constant';
import { isNogarnish } from '$lib/utils/nogarnish';

function setupTeadsPixel() {
	window.teads_e = window.teads_e || [];
	window.teads_buyer_pixel_id = TEADS_BUYER_PIXEL_ID;

	addScriptTag(SCRIPT_ID, SCRIPT_SRC, {
		attributes: { fetchpriority: 'low' },
		loadType: 'async',
	});
}

function isUtmsValid() {
	const urlParams = page.url.searchParams;
	return (
		urlParams.get('utm_source') === 'teads'
        && urlParams.get('utm_medium') === 'paidvideo'
        && urlParams.get('utm_campaign') === 'vm_fr_ete2025_nurture'
        && urlParams.get('utm_content') === 'video_notoriete'
	);
}

export function useTeadsPixel() {
	const locale = getLanguageCode();
	if (!browser || isNogarnish() || locale !== 'fr' || !isUtmsValid()) {
		return;
	}

	handleVendorConsent(TEADS_PIXEL_VENDOR_ID, setupTeadsPixel);
}
